import axios from 'axios';

import type { AxiosResponse } from 'axios';

import ApiConfig from './ApiConfig';

import type { Section, TopicPage } from './types';

const kbapi = axios.create();

kbapi.interceptors.request.use(
  async (config) => {
    config.baseURL = ApiConfig.getConfig().API_URL;
    return config;
  },
  (error) => Promise.reject(error)
);

export const KBApi = {
  getBaseUrl: () => {
    return kbapi.defaults.baseURL;
  },
  getSettings: (viewId: string) => {
    return kbapi.get(`/view/${viewId}/settings`);
  },
  getFrontpage: (viewId: string) => {
    return kbapi.get(`/view/${viewId}`);
  },
  getArticleById: (viewId: string, id: string) => {
    return kbapi.get(`/view/${viewId}/articles/${id}`);
  },
  getSectionById: (viewId: string, categoryId: string): Promise<AxiosResponse<Section>> => {
    return kbapi.get<Section>(`/view/${viewId}/categories/${categoryId}`);
  },
  getTopicById: (viewId: string, categoryId: string, tagId: string): Promise<AxiosResponse<TopicPage>> => {
    return kbapi.get<TopicPage>(`/view/${viewId}/categories/${categoryId}/tags/${tagId}`);
  },
  searchArticlesBy: (viewId: string, query: string) => {
    return kbapi.post(`/view/${viewId}/search?q=${query}`);
  }
};
